import {
    FETCH_LOYALTY_CONSENT_REQUEST,
    FETCH_LOYALTY_CONSENT_SUCCESS,
    FETCH_LOYALTY_CONSENT_ERROR,
} from '../constants/ActionTypes'

const initialState = {
    loading: false,
    error: null,
}

export default function loyaltyConsent(state = initialState, action) {
    switch (action.type) {
        case FETCH_LOYALTY_CONSENT_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_LOYALTY_CONSENT_SUCCESS:
            return {
                ...state,
                attribute: {
                    [action.body.data.attributeName]: action.body.data.attributeValue.value,
                },
                loading: false,
            }
        case FETCH_LOYALTY_CONSENT_ERROR:
            return {
                ...state,
                error: action.body.errors?.[0].errorKey,
                loading: false,
            }
        default:
            return state
    }
}
